import { styled } from "styled-components";
import PlayerBar from "./PlayerBar";
import PlayerControl from "./PlayerControl";
import { useEffect, useState } from "react";



const ProgressBarContainer = styled.div`
    width: 100%;
    // height: 125px;
    display: flex;
    flex-direction: column;
    gap: 7px;
    // padding-top: 40px;
`;



const Controls = styled.div`
    width: 100%;
`;

interface VideProps{
    index: number;
    status: "PLAYED" | "PLAYING" | "TOPLAY";
    progress: number;
    duration: number;
}

interface ProgressBarProps{
    currentIndex: number;
    videos: VideProps[];
    progress: number;
    playing?: boolean;
    totalDuration: number;
    hideShuffle?: boolean;
    hideRepeat?: boolean;
    hideMute?: boolean;
    hideDuration?: boolean;
    hideTagging?: boolean;
    hideNavs?: boolean;
    hideQueueBtn?: boolean;
    barColor?: string;
    onSelectVideo: (index: number) => void;
    onPlay: (status: boolean)=>void;
    onRepeat: (status: boolean)=>void;
    onMute: (status: boolean)=>void;
    onShuffle: (status: boolean)=>void;
}
const ProgressBar: React.FC<ProgressBarProps>=({
    currentIndex, 
    videos, 
    progress, 
    playing,
    totalDuration, 
    onPlay, 
    onRepeat, 
    onMute, 
    onShuffle,
    hideMute,
    hideRepeat,
    hideShuffle,
    hideDuration,
    hideTagging,
    onSelectVideo,
    hideNavs,
    hideQueueBtn,
    barColor="#e0e0e0"
})=>{
    const [loadedVideos, setLoadedVideos] = useState<VideProps[]>([]);
    const [currentTime, setCurrentTime] = useState<number>(0);
    const [currentVideoIndex, setCurrentVideoIndex] = useState<number>(currentIndex);
    const [totalPlayedDuration, setTotalPlayedDuration] = useState<number>(0);
    
   

    const handlePlay=(status: boolean)=>{
        onPlay(status);
    }

    const handleMute=(status: boolean)=>{
        onMute(status);
    }

    const handleShuffle = (status: boolean) => {
        onShuffle(status);
    };

    useEffect(()=>{
        if(progress > 0){
            setCurrentTime(progress);
        }
    }, [progress]);

    useEffect(()=>{
        if(currentIndex > -1){
            setCurrentVideoIndex(currentIndex);
        }
    }, [currentIndex]);

  /*   useEffect(()=>{
        if(videos && videos.length){
            console.log("hhhhhh")
            setLoadedVideos(videos);
            const total = videos
                .filter(video => video.status === 'PLAYED')
                .reduce((sum, video) => sum + (video?.duration || 0), 0);

            setTotalPlayedDuration(total);
        }
    }, [videos]); */


    return(
        <ProgressBarContainer>
            <PlayerBar 
                videos={loadedVideos} 
                currentIndex={currentVideoIndex} 
                onSelectVideo={onSelectVideo}
                hideNavs={hideNavs}
                barColor={barColor}
            />
            <Controls>
                <PlayerControl 
                    playing={playing}
                    hideMute={hideMute}
                    hideRepeat={hideRepeat}
                    hideShuffle={hideShuffle}
                    hideDuration={hideDuration}
                    hideTagging={hideTagging}
                    totalDuration={totalDuration} 
                    totalPlayed={totalPlayedDuration}
                    duration={currentTime} 
                    onPlay={handlePlay} 
                    onRepeat={onRepeat} 
                    totalVideos={videos.length} 
                    currentVideo={currentVideoIndex} 
                    onMute={handleMute}
                    onShuffle={handleShuffle}
                    hideQueueBtn={hideQueueBtn}
                />
            </Controls>
        </ProgressBarContainer>
    )
}

export default ProgressBar;